import * as R from 'ramda';
import { LevelGranulometryFullFilled } from '../../../LevelGranulometry';
import { getLevelSections } from '../../sections/getLevelSections';
import { filterHalls, HallSection } from '../../../../sections/circulationSections/hall';

export const getInFullFilledTopLevelHallSections = (
  levelGranulometry: LevelGranulometryFullFilled
): HallSection[] => R.pipe(getLevelSections, filterHalls)(levelGranulometry);
